import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// ng2-pdf-viewer defaults to loading the pdf.js worker from cdn.jsdelivr.net, which the CSP blocks.
(window as any).pdfWorkerSrc = 'assets/pdfjs/pdf.worker.min.mjs';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
